import { all, takeEvery, fork, put, select } from 'redux-saga/effects';
import StorageManager from '../../helpers/storageManager';
import { dynamicTabsActions, dynamicTabsActionsInterfaces, dynamicTabsActionTypes, dynamicTabsSelectors } from '.';
import { RefreshFilterValues as StronaPrzedmiotuRefreshFilterValues } from './stronaPrzedmiotu/interfaces';
import { FILTERS_REFRESH_VALUES_START as STRONA_PRZEDMIOTU_FILTERS_REFRESH_VALUES_START } from './stronaPrzedmiotu/types';
import { openNewTab, setActiveTab } from './actions';
import { staticTabsList } from '../../settings/staticTabsList';
import StringBuilder from '../../helpers/StringBuilder';
import { authSelectors } from '../auth';

export const SetTabConfigName = 'TABS_CONFIG';

export function* initWatcher(): Generator {
  yield takeEvery(dynamicTabsActionTypes.TABS_INIT, init);
}
// eslint-disable-next-line require-yield

/**
 * inicjalizacja zakładek
 *
 * @export
 * @param {*} { payload }
 * @return {*}  {Generator}
 */
export function* init({ payload }: dynamicTabsActionsInterfaces.InitTabs): Generator {
  //otwórz zakładki zapisane w localStorage
  const userId = (yield select(authSelectors.getUserId));
  const tabConfigFromStorage = StorageManager.get(SetTabConfigName);
  const tabConfigFromStorageWithCorrectId = tabConfigFromStorage && tabConfigFromStorage.length ? JSON.parse(tabConfigFromStorage).id === userId ? tabConfigFromStorage : undefined : undefined;

  if (tabConfigFromStorageWithCorrectId && tabConfigFromStorageWithCorrectId.length) {
    const parsedConfig = JSON.parse(tabConfigFromStorageWithCorrectId).tabConfig;
    const query = payload.path;
    const parts = query.split('/');
    const tabType = parts[parts.length - 2];
    const itemId = parts[parts.length - 1];
    StorageManager.remove(SetTabConfigName);
    for (let index = 0; index < parsedConfig.length; index++) {
      const historyPush = itemId ? parsedConfig[index].itemId !== itemId : parsedConfig.length - 1 !== index;
      yield put(openNewTab(parsedConfig[index], payload.history, historyPush, parsedConfig.length));
    }
    // otwórz zakładkę, jeśli adres url zawiera prawidłowy typ zakładki dynamicznej
    const tabsInLocalStorage = StorageManager.get(SetTabConfigName) || '[]';
    const tabsInLocalStorageParsed = JSON.parse(tabsInLocalStorage);
    const tabList = (yield select(dynamicTabsSelectors.getDynamicTabListFromStore)) as TabList;
    const activeTab = (yield select(dynamicTabsSelectors.getActiveTab)) as DynamicTabsState['activeTab'];
    const openedTabIndex = tabList.findIndex(item => item.itemId === itemId);
    if (tabType.length && itemId.length && activeTab !== openedTabIndex.toString()) {
      yield put(openNewTab({
        titleTranslationKey: tabType,
        tabType: tabType as DynamicTabAttributes['tabType'],
        itemId,
      }, payload.history));
    }
    else if (itemId && !tabType) {
      const activeTabIndex = staticTabsList.findIndex(tab => tab.path.includes(itemId));
      if (activeTabIndex > -1) {
        payload.history.push(staticTabsList[activeTabIndex].path);
        yield put(setActiveTab(`static_${activeTabIndex}`));

      } else {
        payload.history.push(staticTabsList[0].path);
        yield put(setActiveTab('static_0'));
      }
    }
    else if (!itemId.length && !tabsInLocalStorageParsed.length) {
      payload.history.push(staticTabsList[0].path);
      yield put(setActiveTab('static_0'));
    }
  }
  else {
    yield payload.history.push(staticTabsList[0].path);
    yield put(setActiveTab('static_0'));
  }
}
export function* saveTabConfigWatcher(): Generator {
  yield takeEvery([
    dynamicTabsActionTypes.TAB_OPEN_NEW,
    dynamicTabsActionTypes.TAB_CLOSE,
    dynamicTabsActionTypes.TABS_CLOSE_ALL,
  ], saveTabConfig);
}
/**
 * zapisywanie konfiguracji zakładek w local Storage
 *
 * @export
 * @param {*} { payload }
 * @return {*}  {Generator}
 */
export function* saveTabConfig(): Generator {
  const userId = (yield select(authSelectors.getUserId));
  const tabList = (yield select(dynamicTabsSelectors.getDynamicTabListFromStore)) as TabList;
  const tabsParsed = tabList.map(({ titleTranslationKey, itemId, tabType, id: incrementId }) =>
    ({ titleTranslationKey, itemId, tabType, id: incrementId }));

  StorageManager.set(SetTabConfigName, `${JSON.stringify({id: userId, tabConfig: tabsParsed})}`);
}
export function* openTabWatcher(): Generator {
  yield takeEvery(dynamicTabsActionTypes.TAB_OPEN_NEW, openTab);
}
/**
 * otwarcie nowej zakładki
 *
 * @export
 * @param {*} { payload, noHistoryPush }
 * @return {*}  {Generator}
 */
export function* openTab({ payload, noHistoryPush }: dynamicTabsActionsInterfaces.OpenTab): Generator {
  if (!noHistoryPush) {
    const {
      tabType,
      itemId,
      history,
    } = payload;
    yield history.push(`/${tabType}/${itemId}`);
  }
}
export function* closeTabWatcher(): Generator {
  yield takeEvery(dynamicTabsActionTypes.TAB_CLOSE, closeTab);
}
/**
 * zamknięcie zakładki
 *
 * @export
 * @param {*} { payload }
 * @return {*}  {Generator}
 */
export function* closeTab({ payload }: any): Generator {
  const tabList = (yield select(dynamicTabsSelectors.getDynamicTabListFromStore)) as TabList;
  const {
    index,
    history,
    tabType,
    activeTabId,
  } = payload;
  const prevTab = tabList[Number(index) - 1];
  if(index === activeTabId) {
    prevTab ?
      yield history.push(`/${prevTab.tabType}/${prevTab.itemId}`) :
      yield history.push(pushToStaticTab(tabType));
  }
}

const pushToStaticTab = (tabType: string): string => {
  switch (tabType) {
    case 'strona-przedmiotu':
      return staticTabsList[0].path;

    case 'karta-przedmiotu':
      return staticTabsList[2].path;

    default:
      return staticTabsList[0].path;
  }
};

export function* initTabTransferWatcher(): Generator {
  yield takeEvery(dynamicTabsActionTypes.INIT, initTabTransfer);
}
export function* initTabTransfer(action: dynamicTabsActionsInterfaces.Init): Generator {
  const { tabType } = (yield select(state => dynamicTabsSelectors.getTabData(state, action.payload.tabId))) as DynamicTabWithTable<unknown>;
  yield put({
    type: `${StringBuilder.dashToUnderscoreUpperCase(tabType)}/INIT`,
    payload: action.payload,
  });
}

export function* getRecordDetailsTransferWatcher(): Generator {
  yield takeEvery(dynamicTabsActionTypes.RECORD_GET_DETAILS_START, getRecordDetailsTransfer);
}
export function* getRecordDetailsTransfer(action: dynamicTabsActionsInterfaces.GetRecordDetailsStart): Generator {
  const { tabType } = (yield select(state => dynamicTabsSelectors.getTabData(state, action.payload.tabId))) as DynamicTabWithTable<unknown>;
  yield put({
    type: `${StringBuilder.dashToUnderscoreUpperCase(tabType)}/RECORD_GET_DETAILS_START`,
    payload: action.payload,
  });
}
export function* refreshDataTransferWatcher(): Generator {
  yield takeEvery(dynamicTabsActionTypes.REFRESH_DATA_START, refreshDataTransfer);
}
export function* refreshDataTransfer(action: dynamicTabsActionsInterfaces.RefreshDataStart): Generator {
  const { tabType } = (yield select(state => dynamicTabsSelectors.getTabData(state, action.payload.tabId))) as DynamicTabWithTable<unknown>;
  yield put({
    type: `${StringBuilder.dashToUnderscoreUpperCase(tabType)}/REFRESH_DATA_START`,
    payload: action.payload,
  });
}

export function* refreshSelectedDataTransferWatcher(): Generator {
  yield takeEvery(dynamicTabsActionTypes.REFRESH_SELECTED_DATA_START, refreshSelectedDataTransfer);
}
export function* refreshSelectedDataTransfer(action: dynamicTabsActionsInterfaces.RefreshSelectedDataStart): Generator {
  const { tabType } = (yield select(state => dynamicTabsSelectors.getTabData(state, action.payload.tabId))) as DynamicTabWithTable<unknown>;
  yield put({
    type: `${StringBuilder.dashToUnderscoreUpperCase(tabType)}/REFRESH_SELECTED_DATA_START`,
    payload: action.payload,
  });
}


export function* syncDataWithCacheTransferWatcher(): Generator {
  yield takeEvery(dynamicTabsActionTypes.SYNC_DATA_WITH_CACHE_START, syncDataWithCacheTransfer);
}
export function* syncDataWithCacheTransfer(action: dynamicTabsActionsInterfaces.SyncDataWithCacheStart): Generator {
  const { tabType } = (yield select(state => dynamicTabsSelectors.getTabData(state, action.payload.tabId))) as DynamicTabWithTable<unknown>;
  yield put({
    type: `${StringBuilder.dashToUnderscoreUpperCase(tabType)}/SYNC_DATA_WITH_CACHE_START`,
    payload: action.payload,
  });
}

export function* clearSelectedWatcher(): Generator {
  yield takeEvery([
    dynamicTabsActionTypes.SET_ORDER,
    STRONA_PRZEDMIOTU_FILTERS_REFRESH_VALUES_START,
    dynamicTabsActionTypes.SET_SEARCH,
  ], clearSelected);
}
/**
 * wyczyszczenie tablicy zaznaczonych elementów tabeli & zwijanie rekordu
 * Wykonując akcje na tabeli takie jak sortowanie (po backendzie), odświeżenie listy filtrów, wyszukiwanie rekordów po wartości (po backendzie):
 * - zmieniamy stronę na 1, aby paginowalne dane pobierały się od pierwszej strony,
 * - resetujemy rekordy zaznaczone w tabeli oraz zwijamy rekord tabeli, jeśli jakiś jest rozwinięty.
 *
 *
 * @export
 * @return {*}  {Generator}
 */
export function* clearSelected(
  action: dynamicTabsActionsInterfaces.SetOrder | dynamicTabsActionsInterfaces.SetSearch | StronaPrzedmiotuRefreshFilterValues): Generator {
  const { tabId } = action.payload;
  const { table } = (yield select(state => dynamicTabsSelectors.getTabData(state, action.payload.tabId))) as DynamicTabWithTable<unknown>;
  yield put(dynamicTabsActions.setPage(tabId, 1));
  if (table.selected.length) {
    yield put(dynamicTabsActions.setSelected(tabId, []));
  }
  if (table.expanded) {
    yield put(dynamicTabsActions.setExpanded(tabId, null));
  }
}


export function* refreshFilterValuesTransferWatcher(): Generator {
  yield takeEvery([
    dynamicTabsActionTypes.FILTERS_SELECT_VALUES,
    dynamicTabsActionTypes.FILTERS_CLOSE_CATEGORY,
    dynamicTabsActionTypes.FILTERS_OPEN_CATEGORY,
  ], refreshFilterValuesTransfer);
}
/**
 * inicjalizacja odświeżenia listy wartości filtrów
 *
 * @export
 * @return {*}  {Generator}
 */
export function* refreshFilterValuesTransfer(
  action: dynamicTabsActionsInterfaces.OpenFilterCategory | dynamicTabsActionsInterfaces.CloseFilterCategory | dynamicTabsActionsInterfaces.SelectFilterValues): Generator {
  const { tabId } = action.payload;
  const { initTable, tabType, table } = (yield select(state => dynamicTabsSelectors.getTabData(state, tabId))) as DynamicTabWithTable<unknown>;
  if (!initTable && !table.filters.loading) {
    yield put({
      type: `${StringBuilder.toUnderscoreUpperCase(tabType)}/FILTERS_REFRESH_VALUES_START`,
      payload: { tabId },
    });
  }
}

export default function* rootSaga(): Generator {
  yield all([
    fork(initWatcher),
    fork(saveTabConfigWatcher),
    fork(openTabWatcher),
    fork(closeTabWatcher),
    fork(initTabTransferWatcher),
    fork(getRecordDetailsTransferWatcher),
    fork(refreshDataTransferWatcher),
    fork(refreshSelectedDataTransferWatcher),
    fork(syncDataWithCacheTransferWatcher),
    fork(clearSelectedWatcher),
    fork(refreshFilterValuesTransferWatcher),
  ]);
}
